import { Row, Col, Button, Form, FormCheck } from "react-bootstrap";
import { useFormik } from "formik";
import { useState, useRef, useEffect } from "react";
import { addNewYandex, addNewYandexCSV } from "../../Redux/Actions/YandexActions";

interface createNewYandexProps {
  dispatch: any;
  setIsPopUp: any;
}

const CreateNewYandex = ({ dispatch, setIsPopUp }: createNewYandexProps) => {
  const [typeSelection, setTypeSelection] = useState<any>("cpm");
  const [formSelection, setFormSelection] = useState<any>("banner");
  const [csv_file, set_csv_file] = useState<any>({});
  const fileUploadRef = useRef<HTMLInputElement>(null);
  const [isUploadSelected, setIsUploadSelected] = useState(true);
  const [isCsv,setIsCsv] = useState(false)


  const typesOptions = [{ value: "cpm", label: "CPM" }];

  const formsOptions = [{ value: "banner", label: "Banner" }];

  const inventoryOptions = [{ value: "app", label: "InApp"}, { value: "web", label: "Web"}];

  const trueFalseOptions = [{ value: true, label: "True"}, { value: false, label: "False"}]

  const formik: any = useFormik({
    initialValues: {
      orgId: "",
      des: "",
      domUrl: '',
      creativeUrl: "", 
      mediaDes: "",
      myDspCreativeId: "",
      clickUrl: "",
      type: "cpm",
      form: "banner",
      social: true,
      native: false,
      coBrand: false,
    },

    onSubmit: (value, { resetForm }) => {
      const newYandex: any = {
        orgId: value.orgId,
        des: value.des,
        domUrl: value.domUrl.split(",").map((url: string) => url.trim()),
        creativeUrl: value.creativeUrl, 
        mediaDes: value.mediaDes,
        myDspCreativeId: value.myDspCreativeId,
        clickUrl: value.clickUrl,
        type: value.type,
        form: value.form,
        social: value.social,
        native: value.native,
        coBrand: value.coBrand,
      };
      if(isCsv){
        const formData = new FormData();
        formData.append('csv', csv_file)
        dispatch(addNewYandexCSV(formData))
      } else {
        dispatch(addNewYandex(newYandex));
      }
      setIsPopUp(false);
    },
  });


  const handleCSVUpload = (event: any) => {
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    }
    // Check if the selected file is a CSV file
    if (fileObj && fileObj.name.endsWith('.csv')) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
            set_csv_file(fileObj)
            };
            reader.readAsText(fileObj); // Read the file content
        } else {
            alert('Please select a valid CSV file.');
        }
    };



  const handleFileUpload = () => {
    if (fileUploadRef) {
      fileUploadRef?.current?.click();
    }
  }

const downloadCSVFile = () => {
  let csvContent: any;
  let fileName;
  csvContent = `creative_base_name,org_id,advertiser_name,advertiser_id,domain_url,click_url,type,form,social,native,cobranding,size_name,size_key,creative_url
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,1024x552,37,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_1024X552.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,1024x768,6,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_1024X768.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,120x100,22,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_120X100.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,160x600,28,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_160X600.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,200x200,23,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_200X200.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,250x250,25,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_250X250.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,300x100,20,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_300X100.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,300x250,11,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_300X250.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,300x50,10,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_300X50.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,300x600,15,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_300X600.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,320x100,17,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_320X100.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,320x320,21,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_320X320.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,320x480,2,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_320X480.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,320x50,1,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_320X50.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,336x280,18,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_336X280.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,360x56,19,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_360X56.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,468x60,24,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_468X60.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,480x320,3,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_480X320.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,728x90,4,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_728X90.png,
Yandex-RUS-InApp-ReMeWh-Girl_Ad,c-D5Y7-cY2mDUre8M2CdqtkieUFtz,RemindMeWhere,22885,https://www.remindmewhere.app,https://remindmewhere.app/applink/?utm_source=mydsp&utm_medium=cpm&utm_campaign=main&utm_term=Banner,CPM,Banner,TRUE,FALSE,FALSE,768x1024,5,https://cloud-images.s3.eu-west-1.amazonaws.com/MyDSP_Beeswax/RMW/Girl_Laptop_RUS/RMW_RUS_Girl_768X1024.png,`;
      fileName = 'Yandex_Example';

  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `${fileName}.csv`;

  a.click();
  window.URL.revokeObjectURL(url);
}
  return (
    <>
      <div>
        <div className="popUp">
          <Row className="d-flex justify-content-center mt-3">
            <Row>
              <h3 className="module_title">New Yandex Creative</h3>
            </Row>
          </Row>
          <div className="form">
          <Form.Group
                          as={Row}
                          className="mb-0"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "15px",
                          }}
                        >
          <Col lg={9} style={{ marginTop: '15px' }}>
    <input
        ref={fileUploadRef}
        style={{ display: 'none' }}
        type="file"
        accept=".csv"
        onChange={(e) => handleCSVUpload(e)}
    />

    <div className="d-flex flex-wrap gap-2">
        <Form.Check type="radio" name="csvOption" className="mt-1" checked={isUploadSelected} onClick={() => setIsUploadSelected(true)}/>
        <Form.Label column lg={2} id="smallerFontSize"> Upload creative with CSV File </Form.Label>
        <span
            style={{
                textDecoration: "none",
                color: '#0077b6',
                fontWeight: 'bold',
                margin: '8px',
                cursor: 'pointer'
            }}
            onClick={() => downloadCSVFile()}
        >
            Download CSV Example
        </span>
        <Button className="m-0" variant="primary" onClick={() => handleFileUpload()} disabled={!isUploadSelected}>
            Upload CSV
        </Button>
        <Button className="m-0" variant={csv_file && isUploadSelected?"success":"secondary"} disabled={!isUploadSelected || !csv_file} 
        onClick={()=> {
          setIsCsv(true);
          formik.handleSubmit()}}>
            Continue
        </Button>
        {csv_file?.name && (
            <Col lg={5} className="mt-1">
                <span>{csv_file?.name}</span>
            </Col>
        )}
    </div>

    <Form.Label column lg={1} id="smallerFontSize"> OR </Form.Label>

    
    <div className="d-flex flex-wrap gap-2 mb-2">
    <Form.Check type="radio" name="csvOption" className="mt-1" checked={!isUploadSelected} onClick={() => setIsUploadSelected(false)}/>
    <Form.Label column lg={4} id="smallerFontSize">Upload a single creative manually</Form.Label>
    </div>
</Col>
</Form.Group>

                                                
            <Row>
              <Col md={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label
                    column
                    lg={3}
                    htmlFor="simpleinput"
                    id="smallerFontSize"
                  >
                    Organization ID{" "}
                    {formik.errors?.orgId?.includes("*") && (
                      <span
                        style={{
                          color: "#dc3545",
                          fontFamily: "Silka",
                          fontSize: 12,
                        }}
                      >
                        *
                      </span>
                    )}
                  </Form.Label>
                  <Col lg={9}>
                    <Form.Control
                      name="orgId"
                      type="text"
                      autoComplete="off"
                      id="simpleinput"
                      defaultValue={formik.values.orgId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="fsz-875rem"
                      isInvalid={!!formik.errors.orgId}
                      disabled={isUploadSelected}
                    />
                    <Form.Control.Feedback type="invalid">
                      {" "}
                      {formik.errors?.orgId?.includes("*") ||
                      formik.errors?.orgId?.includes("required")
                        ? ""
                        : formik.errors.orgId}{" "}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label
                    column
                    lg={3}
                    htmlFor="simpleinput"
                    id="smallerFontSize"
                  >
                    Description{" "}
                    {formik.errors?.des?.includes("*") && (
                      <span
                        style={{
                          color: "#dc3545",
                          fontFamily: "Silka",
                          fontSize: 12,
                        }}
                      >
                        *
                      </span>
                    )}
                  </Form.Label>
                  <Col lg={9}>
                    <Form.Control
                      name="des"
                      type="text"
                      autoComplete="off"
                      id="simpleinput"
                      defaultValue={formik.values.des}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="fsz-875rem"
                      isInvalid={!!formik.errors.des}
                      disabled={isUploadSelected}
                    />
                    <Form.Control.Feedback type="invalid">
                      {" "}
                      {formik.errors?.des?.includes("*") ||
                      formik.errors?.des?.includes("required")
                        ? ""
                        : formik.errors.des}{" "}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label
                    column
                    lg={3}
                    htmlFor="simpleinput"
                    id="smallerFontSize"
                  >
                    Domain URL{" "}
                    {formik.errors?.domUrl?.includes("*") && (
                      <span
                        style={{
                          color: "#dc3545",
                          fontFamily: "Silka",
                          fontSize: 12,
                        }}
                      >
                        *
                      </span>
                    )}
                  </Form.Label>
                  <Col lg={9}>
                    <Form.Control
                      name="domUrl"
                      type="text"
                      autoComplete="off"
                      id="simpleinput"
                      value={formik.values.domUrl}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="fsz-875rem"
                      isInvalid={!!formik.errors.domUrl}
                      disabled={isUploadSelected}
                    />
                    <Form.Control.Feedback type="invalid">
                      {" "}
                      {formik.errors?.domUrl?.includes("*") ||
                      formik.errors?.domUrl?.includes("required")
                        ? ""
                        : formik.errors.domUrl}{" "}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label
                    column
                    lg={3}
                    htmlFor="simpleinput"
                    id="smallerFontSize"
                  >
                    Creative URL{" "}
                    {formik.errors?.creativeUrl?.includes("*") && (
                      <span
                        style={{
                          color: "#dc3545",
                          fontFamily: "Silka",
                          fontSize: 12,
                        }}
                      >
                        *
                      </span>
                    )}
                  </Form.Label>
                  <Col lg={9}>
                    <Form.Control
                      name="creativeUrl"
                      type="text"
                      autoComplete="off"
                      id="simpleinput"
                      defaultValue={formik.values.creativeUrl}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="fsz-875rem"
                      isInvalid={!!formik.errors.creativeUrl}
                      disabled={isUploadSelected}
                    />
                    <Form.Control.Feedback type="invalid">
                      {" "}
                      {formik.errors?.creativeUrl?.includes("*") ||
                      formik.errors?.creativeUrl?.includes("required")
                        ? ""
                        : formik.errors.creativeUrl}{" "}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label
                    column
                    lg={3}
                    htmlFor="simpleinput"
                    id="smallerFontSize"
                  >
                    MyDSP Creative ID{" "}
                    {formik.errors?.myDspCreativeId?.includes("*") && (
                      <span
                        style={{
                          color: "#dc3545",
                          fontFamily: "Silka",
                          fontSize: 12,
                        }}
                      >
                        *
                      </span>
                    )}
                  </Form.Label>
                  <Col lg={9}>
                    <Form.Control
                      name="myDspCreativeId"
                      type="text"
                      autoComplete="off"
                      id="simpleinput"
                      defaultValue={formik.values.myDspCreativeId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="fsz-875rem"
                      isInvalid={!!formik.errors.myDspCreativeId}
                      disabled={isUploadSelected}
                    />
                    <Form.Control.Feedback type="invalid">
                      {" "}
                      {formik.errors?.myDspCreativeId?.includes("*") ||
                      formik.errors?.myDspCreativeId?.includes("required")
                        ? ""
                        : formik.errors.myDspCreativeId}{" "}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label
                    column
                    lg={3}
                    htmlFor="simpleinput"
                    id="smallerFontSize"
                  >
                    Media Description{" "}
                    {formik.errors?.mediaDes?.includes("*") && (
                      <span
                        style={{
                          color: "#dc3545",
                          fontFamily: "Silka",
                          fontSize: 12,
                        }}
                      >
                        *
                      </span>
                    )}
                  </Form.Label>
                  <Col lg={9}>
                    <Form.Control
                      name="mediaDes"
                      type="text"
                      autoComplete="off"
                      id="simpleinput"
                      defaultValue={formik.values.mediaDes}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="fsz-875rem"
                      isInvalid={!!formik.errors.mediaDes}
                      disabled={isUploadSelected}
                    />
                    <Form.Control.Feedback type="invalid">
                      {" "}
                      {formik.errors?.mediaDes?.includes("*") ||
                      formik.errors?.mediaDes?.includes("required")
                        ? ""
                        : formik.errors.mediaDes}{" "}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label
                    column
                    lg={3}
                    htmlFor="simpleinput"
                    id="smallerFontSize"
                  >
                    Click URL{" "}
                    {formik.errors?.clickUrl?.includes("*") && (
                      <span
                        style={{
                          color: "#dc3545",
                          fontFamily: "Silka",
                          fontSize: 12,
                        }}
                      >
                        *
                      </span>
                    )}
                  </Form.Label>
                  <Col lg={9}>
                    <Form.Control
                      name="clickUrl"
                      type="text"
                      autoComplete="off"
                      id="simpleinput"
                      defaultValue={formik.values.clickUrl}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="fsz-875rem"
                      isInvalid={!!formik.errors.clickUrl}
                      disabled={isUploadSelected}
                    />
                    <Form.Control.Feedback type="invalid">
                      {" "}
                      {formik.errors?.clickUrl?.includes("*") ||
                      formik.errors?.clickUrl?.includes("required")
                        ? ""
                        : formik.errors.clickUrl}{" "}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label column lg={3} id="smallerFontSize">
                    {" "}
                    Type{" "}
                  </Form.Label>
                  <Col lg={9}>
                    <Form.Select
                      className="fsz-875rem"
                      name="type"
                      disabled={typesOptions.length <= 1 || isUploadSelected}
                      placeholder="open this select menu"
                      value={typeSelection}
                      onChange={async (e) => {
                        await setTypeSelection(e.target.value);
                        formik.setFieldValue("type", e.target.value);
                        formik.validateForm();
                      }}
                    >
                      {typesOptions &&
                        typesOptions.map((type, index) => (
                          <option key={index} value={type.value}>
                            {type.label}
                          </option>
                        ))}
                    </Form.Select>
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label column lg={3} id="smallerFontSize">
                    {" "}
                    Form{" "}
                  </Form.Label>
                  <Col lg={9}>
                    <Form.Select
                      className="fsz-875rem"
                      name="form"
                      disabled={formsOptions.length <= 1 || isUploadSelected}
                      placeholder="open this select menu"
                      value={formSelection}
                      onChange={async (e) => {
                        await setFormSelection(e.target.value);
                        formik.setFieldValue("form", e.target.value);
                        formik.validateForm();
                      }}
                    >
                      {formsOptions &&
                        formsOptions.map((form, index) => (
                          <option key={index} value={form.value}>
                            {form.label}
                          </option>
                        ))}
                    </Form.Select>
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label column lg={3} id="smallerFontSize">
                    {" "}
                    Social{" "}
                  </Form.Label>
                  <Col lg={9}>
                    <Form.Select
                      className="fsz-875rem"
                      name="social"
                      placeholder="open this select menu"
                      disabled={isUploadSelected}
                      onChange={async (e) => {
                        const value = e.target.value == "true"? true : e.target.value == "false"? false : '';
                        await formik.setFieldValue("social", value);
                        formik.validateForm();
                      }}
                    >
                      {trueFalseOptions &&
                        trueFalseOptions.map((option, index) => (
                          <option key={index} value={String(option.value)}>
                            {option.label}
                          </option>
                        ))}
                    </Form.Select>
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label column lg={3} id="smallerFontSize">
                    {" "}
                    Native{" "}
                  </Form.Label>
                  <Col lg={9}>
                    <Form.Select
                      className="fsz-875rem"
                      name="native"
                      defaultValue={formik.values.native}
                      placeholder="open this select menu"
                      disabled={isUploadSelected}
                      onChange={async (e) => {
                        const value = e.target.value == "true"? true : e.target.value == "false"? false : '';
                        await formik.setFieldValue("native", value);
                        formik.validateForm();
                      }}
                    >
                      {trueFalseOptions &&
                        trueFalseOptions.map((option, index) => (
                          <option key={index} value={String(option.value)}>
                            {option.label}
                          </option>
                        ))}
                    </Form.Select>
                  </Col>
                </Form.Group>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label column lg={3} id="smallerFontSize">
                    {" "}
                    CoBranding{" "}
                  </Form.Label>
                  <Col lg={9}>
                    <Form.Select
                      className="fsz-875rem"
                      name="coBrand"
                      defaultValue={formik.values.coBrand}
                      placeholder="open this select menu"
                      disabled={isUploadSelected}
                      onChange={async (e) => {
                        const value = e.target.value == "true"? true : e.target.value == "false"? false : '';
                        await formik.setFieldValue("coBrand", value);
                        formik.validateForm();
                      }}
                    >
                      {trueFalseOptions &&
                        trueFalseOptions.map((option, index) => (
                          <option key={index} value={String(option.value)}>
                            {option.label}
                          </option>
                        ))}
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>
            </Row>

            <Row style={{ margin: "10px" }}>
              <Col>
                <Button
                  style={{ marginLeft: "0", fontWeight: "700" }}
                  variant="primary"
                  onClick={() => {
                    formik.handleSubmit();
                  }}
                >
                  Submit
                </Button>
                <Button
                  variant="outline-danger"
                  onClick={() => {
                    formik.resetForm({
                      values: {
                        orgId: "",
                        des: "",
                        domUrl: [],
                        creativeUrl: "",
                        myDspCreativeId: "",
                        mediaDes: "",
                        clickUrl: "",
                        type: "cpm",
                        form: "banner",
                        social: true,
                        native: false,
                        coBrand: false,
                      },
                    });
                    setIsPopUp(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateNewYandex;
